import * as React from "react";

function SvgDigioh(props, ref) {
  return (
    <svg
      id="Digioh_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 225.3 241.7"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".Digioh_svg__st0{fill:#222525}"}</style>
      <path
        className="Digioh_svg__st0"
        d="M195.1 71.6L214 60.3c-20.7-37-63.9-52.2-101.4-37.9V0C71.2 0 36.9 31 30.1 71.7L11.2 60.4C-9.5 97.4-.7 143.6 30.1 170l-18.9 11.3c20.7 37 63.8 52.2 101.4 37.9v22.5c41.4 0 75.7-31 82.5-71.7l18.9 11.3c20.7-37 11.9-83.2-18.9-109.7zm-2.5 92.5l-28-15.2c-3 23.3-15.6 45-36.3 58.5-3.9 2.5-7.9 4.7-12.1 6.4l-1.3-32.6c-21 8.9-45.6 8.6-67.2-3.2-4.1-2.2-7.9-4.7-11.4-7.6L63 153c-18-14.3-30-36.4-31-61.7-.2-4.8 0-9.4.6-14l28 15.2c3-23.2 15.6-45 36.3-58.5 3.9-2.5 7.9-4.7 12.1-6.4l1.3 32.6c21-9 45.6-8.6 67.3 3.2 4.1 2.2 7.9 4.7 11.4 7.6l-26.7 17.4c18 14.3 30 36.4 31 61.7.1 4.8-.1 9.5-.7 14z"
      />
      <path
        className="Digioh_svg__st0"
        d="M153 94.5l9.2-6C148 77.2 130 70.8 110.7 71.6l-.4-11.3c-16.6 7.1-30.9 19.9-39.9 37.6l-9.7-5.3c-2.4 18.4 1.2 37.6 11.6 54.5l-9.3 6c14.2 11.3 32.2 17.7 51.5 16.9l.4 11.3c16.6-7.1 30.9-19.9 39.9-37.6l9.7 5.2c2.5-18.3-1.2-37.5-11.5-54.4z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgDigioh);
